import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

// import { Link } from "react-router-dom";
// import ProgramTable from '../container/Program/ProgramTable'
// import NewGif from "../components/Gif/NewGif";

// import EmptyOne from '../container/Empty/EmptyOne';

const Program = () => {
  let show = false;
  if (show) {

    return (
      <React.Fragment>
        <SEO title="Program | ICSI 2025" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Program"
          content="The Conference"
          contentTwo="Program"
          linkage="/"
        />

        <EmptyTwo>


          {/* <div className="entry-content title-center">
        <h3>Program Time Table</h3>
        </div>
        <div className="entry-content title-center">
        <h3>Program Schedule</h3>
        
        <ProgramTable/>
        </div>
        
        <div className="space-60"></div>
        
        
        
        
        
        
        
        
        
        <div className="space-40"></div>
        <div className="newfig">
        
        <h4>Detailed Scheduled Presentations Timetables</h4>
        </div>
        
        
        <div className="entry-content2">
        <Link
        className="btn btn-primary btn-hover-secondary  mt-s"
        to={process.env.PUBLIC_URL + "/sessions"}
        >
        Sessions
        </Link>
        
        
        </div> */}
        </EmptyTwo>

        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }

  else {

    return (

      <React.Fragment>
      <SEO title="Program | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Program"
        content="The Conference"
        contentTwo="Program"
        linkage="/"
      />

      <EmptyTwo>

        {/* <div className="announce">
        <h2>The information is to be announced. </h2>
      </div> */}
      <div className="entry-content2">

        <h2>ICSI&apos;2025 Program Schedule</h2>

        <p>
        Welcome to the ICSI&apos;2025 conference program schedule. The detailed program handbook has been published. You can download and view it using the link below:
        </p>


        
        <a
        href={process.env.PUBLIC_URL + "/files/ICSI2025-program-v4.0.pdf"}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary"
        >
        Download ICSI&apos;2025 Program Handbook (PDF)
        </a>

          <div className="space-60"></div>

          <h4>Detailed Scheduled Presentations Timetables</h4>
        </div>
        
        
        <div className="entry-content2">
        <Link
        className="btn btn-primary btn-hover-secondary  mt-s"
        to={process.env.PUBLIC_URL + "/sessions"}
        >
        Sessions
        </Link>
        
        


      </div>

      </EmptyTwo>

      <Footer />
      <ScrollToTop />
      </React.Fragment>
    )
  }

};

export default Program;
